/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { DefaultAppSettingsParams } from '../models/default-app-settings-params';

@Injectable({ providedIn: 'root' })
export class UserApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `bootstrapCurrentUser()` */
  static readonly BootstrapCurrentUserPath = '/api/v1/users';

  /**
   * Bootstrap user planSettings.
   *
   * Ensure currently logged in user exists in our system and then return info about this user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bootstrapCurrentUser$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bootstrapCurrentUser$Plain$Response(
    params: {
      body: DefaultAppSettingsParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(this.rootUrl, UserApiClient.BootstrapCurrentUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Bootstrap user planSettings.
   *
   * Ensure currently logged in user exists in our system and then return info about this user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bootstrapCurrentUser$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bootstrapCurrentUser$Plain(
    params: {
      body: DefaultAppSettingsParams
    },
    context?: HttpContext
  ): Observable<number> {
    return this.bootstrapCurrentUser$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * Bootstrap user planSettings.
   *
   * Ensure currently logged in user exists in our system and then return info about this user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bootstrapCurrentUser()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bootstrapCurrentUser$Response(
    params: {
      body: DefaultAppSettingsParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(this.rootUrl, UserApiClient.BootstrapCurrentUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Bootstrap user planSettings.
   *
   * Ensure currently logged in user exists in our system and then return info about this user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bootstrapCurrentUser$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  bootstrapCurrentUser(
    params: {
      body: DefaultAppSettingsParams
    },
    context?: HttpContext
  ): Observable<number> {
    return this.bootstrapCurrentUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `resetCurrentUser()` */
  static readonly ResetCurrentUserPath = '/api/v1/users';

  /**
   * Completely removes all data related to the current user.
   *
   * Ensure currently logged in user data is completely reset to the same state as before the first login
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetCurrentUser$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, UserApiClient.ResetCurrentUserPath, 'delete');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Completely removes all data related to the current user.
   *
   * Ensure currently logged in user data is completely reset to the same state as before the first login
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resetCurrentUser(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.resetCurrentUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
